import { render, staticRenderFns } from "./userPage.vue?vue&type=template&id=4d50340c"
import script from "./userPage.vue?vue&type=script&lang=js"
export * from "./userPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports